import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { EditCreativeTextTT } from 'features/cabinet';
import { Guard, usePermissionGuard } from 'features/login';

const EditCreativeTextPage: FC = () => {
  const { accessToChangeTiktoktext } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToChangeTiktoktext}>
      <CabinetTitlePage
        title={'Creative texts'}
        goBack={'/cabinet/tiktok/creative-texts'}
      />
      <EditCreativeTextTT />
    </Guard>
  );
};

export default EditCreativeTextPage;
